import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Divider, Card } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './EventInventoryWings.module.css';
import DropDown from '../../../../Subcomponents/DropDown';
import {
  getProjectByProjectName,
} from '../../../../Services/SustenanceService';
import {
  AllotmentDiv,
} from '../../../../Subcomponents/FloorComponent/FloorComponents';
import WingsCard from '../../../../Subcomponents/WingsCard/WingsCard';
import WingsIcon from '../../../../Assets/Images/Common/noProjectFound.svg';
import { getLaunchById } from '../../../../Services/Launch';
import {
  getLaunchInventoryRelations,
  getUnitsOfLaunches,
} from '../../../../Services/Event';
import { sortBy } from 'lodash';
import ViewToggleSwitch from '../../../../Subcomponents/ViewSwitch/ViewToggleSwitch';

function EventInventoryWings() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const navigate = useNavigate();
  const { eventID, projectId, launchId } = useParams();
  const [AllWings, setAllWings] = useState([]);
  const [ProjectData, setProjectData] = useState([]);
  const [launchData, setLaunchData] = useState('');
  const [UnitStatus, setUnitStatus] = useState([]);
  const [TotalWings, setTotalWings] = useState(0);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [mode, setMode] = useState("Card View");
  const [NoWingsFound, setNoWingsFound] = useState(null);

  useEffect(() => {
    dispatch(action.activeMenu('eventinventory'));
    getProject();
  }, []);


  function getProject() {
    getLaunchById(launchId)
      .then((response) => {
        console.log('---->', response.data);
        setLaunchData(response.data);
      })
      .catch((err) => {
        console.error('getLaunchById', err);
      });
    //*Inventory
    getProjectByProjectName(projectId)
      .then((resp) => {
        console.log('Projects', resp);
        setProjectData(resp.data[0]);
        if (resp.data[0]) {
          //*launchInventory
          getLaunchInventoryRelations(launchId)
            .then((response66) => {
              console.log('launchInventory', response66);
              if (response66.data.length > 0) {
                setNoWingsFound(true);
              } else {
                setNoWingsFound(false);
              }
              setAllWings(response66.data);
              setTotalWings(response66.data.length);
            })
            .catch((err) => {
              console.error('launchInventory', err);
            });

          getUnitsOfLaunches(launchId)
            .then((response88) => {
              console.log('launchInventory-units', response88);
              setUnitStatus(response88.data);
              setTotalUnits(response88.count);
            })
            .catch((err) => {
              console.error('launchInventory-units', err);
            });
        }
      })
      .catch((err) => {
        console.error('getProjectByProjectName', err);
      });
  }

  function goToWing(wingName) {
    navigate(
      `/home/Event/Details/${eventID}/Inventory/${launchId}/${projectId}/${wingName}`
    );
  }

  return (
    <Box className={cssClasses.Container}>
      <Box mb={2}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>
              {launchData[0]?.title}{' '}
            </Box>
            <Box >
          <Box className={cssClasses.Title}>
            Project :
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {ProjectData?.projectName}
            </Box>{' '}
          </Box>

          <Box className={cssClasses.Title}>
            Location:
            <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
              {ProjectData?.addressLine1} , {ProjectData?.addressLine2} , {ProjectData?.addressLine3}
            </Box>{' '}
          </Box>
        </Box>
          </Box>

        </Box>

       
      </Box>

      <Divider />


      <Box className={cssClasses.FirstDiv}>
       

        <Box mt={2} >
          <Box className={cssClasses.Title}>
            Total Wings :
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {TotalWings}
            </Box>{' '}
          </Box>
        </Box>

        <Box mt={2} >

          <Box className={cssClasses.Title}>
            Total Units :
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {TotalUnits}
            </Box>{' '}
          </Box>
        </Box>

        <Box  margin={'1rem 2rem'}>
          <ViewToggleSwitch setMode={setMode} />
        </Box>
          
        
      </Box>

      <>
        <Divider />
        <Box className={cssClasses.BoxDiv}  justifyContent={'center'}>
          <AllotmentDiv
            style={{ backgroundColor: '#D1FADF' }}
            content={'Available'}
            Quantity={
              UnitStatus
                ? UnitStatus?.filter(
                  (f) => f.unitId.inventoryStatusId.status === 'Available'
                ).length
                : '0'
            }
          />
          <AllotmentDiv
            style={{ backgroundColor: '#FEF0C7' }}
            content={'On Hold'}
            Quantity={
              UnitStatus
                ? UnitStatus?.filter(
                  (f) => f.unitId.inventoryStatusId.status === 'On Hold'
                ).length
                : '0'
            }
          />
          {/* // ! to hide these status as per client requirement => 28 March, 2023 */}
          {/* <AllotmentDiv
              style={{ backgroundColor: '#FEE4E2' }}
              // content={'Alloted'}
              content={'Payment Pending'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Payment Pending'
                    ).length
                  : '0'
              }
            /> */}


          <AllotmentDiv
            style={{ backgroundColor: '#FFE6D5' }}
            content={'Preselected'}
            Quantity={UnitStatus
              ? UnitStatus?.filter(
                (f) => f.unitId.inventoryStatusId.status === 'Preselected'
              ).length
              : '0'}
          />

          {/* <AllotmentDiv
            style={{ backgroundColor: '#EFF8FF' }}
            content={'Kyc Pending'}
            Quantity={UnitStatus
              ? UnitStatus?.filter(
                  (f) => f.unitId.inventoryStatusId.status === 'Kyc Pending').length : "0"}
          />
           <AllotmentDiv
            style={{ backgroundColor: '#ECFDFF' }}
            content={'Kyc Done'}
            Quantity={UnitStatus
              ? UnitStatus?.filter(
                  (f) => f.unitId.inventoryStatusId.status === 'Kyc Done').length : "0"}
          />
           <AllotmentDiv
            style={{ backgroundColor: '#FFFAEB' }}
            content={'SDR Payment Pending'}
            Quantity={UnitStatus
              ? UnitStatus?.filter(
                  (f) => f.unitId.inventoryStatusId.status === 'SDR Payment Pending').length : "0"}
          />
           <AllotmentDiv
              style={{ backgroundColor: '#F4EBFF' }}
              content={'Reserved'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Reserved'
                    ).length
                  : '0'
              }
            />
            <AllotmentDiv
              style={{ backgroundColor: '#F2F4F7' }}
              content={'Locked'}
              Quantity={
                UnitStatus
                  ? UnitStatus?.filter(
                      (f) => f.unitId.inventoryStatusId.status === 'Locked'
                    ).length
                  : '0'
              }
            /> */}
        </Box>

        <Divider/>

        {mode === 'Card View' && (
          <>
            <Box className={cssClasses.MainDiv}>
              <Box className={cssClasses.FlexRow}>
                {sortBy(AllWings, "wingname")?.map((wing, index) => (
                  <Box component={'span'} key={`${wing}_${index}`}>
                    <WingsCard
                      clicked={() => {
                        goToWing(wing.wingid);
                      }}
                      wingName={wing.displaywingname ? wing.displaywingname : wing.wingname}
                      // wingName={wing.wingname}
                    />
                  </Box>
                ))}
              </Box>
            </Box>

            {NoWingsFound === false && (
              <Box mt={2}>
                <Box className={cssClasses.noDataMsg}>
                  <Box className={cssClasses.emptyIcon}>
                    <img src={WingsIcon} alt='No Wings Available' />
                  </Box>
                  <Box className={cssClasses.emptyTitle}>
                    No Wings were Found
                  </Box>
                </Box>
              </Box>
            )}
          </>
        )}

        {mode === 'Table View' && (
          <Box margin={'1rem'}>
            {sortBy(AllWings, "wingname")?.map((wing, index) => (
              <Box mb={2}>
                <Card
                  onClick={() => {
                    goToWing(wing.wingid);
                  }}
                  sx={{
                    padding: '2rem',
                    fontSize: '1.6rem',
                    fontFamily: 'Inter-Regular',
                    lineHeight: '2.4rem',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    boxShadow:
                      '0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important',
                    borderRadius: '0.8rem !important',
                    border: ' 1px solid rgba(0, 0, 0, 0.12) !important',
                    gap: '1rem',
                    cursor: 'pointer',
                  }}
                  key={`${wing}_${index}`}
                >
                  <Box>Wing {wing.displaywingname ? wing.displaywingname : wing.wingname}</Box>
                  {/* <Box>Wing {wing.wingname}</Box> */}
                </Card>
              </Box>
            ))}

            {NoWingsFound === false && (
              <Box>
                <Box className={cssClasses.noDataMsg}>
                  <Box className={cssClasses.emptyIcon}>
                    <img src={WingsIcon} alt='No Wings' />
                  </Box>
                  <Box className={cssClasses.emptyTitle}>No Wings found</Box>
                </Box>
              </Box>
            )}
          </Box>
        )}
      </>



    </Box>
  )
}

export default EventInventoryWings